var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "store-name" }, [
        _c("div", [_vm._v(_vm._s(_vm.repoortData.storeName))]),
        _vm._v(" "),
        _vm.userId && _vm.userId !== "-1" && _vm.userId !== "1"
          ? _c("div", { on: { click: _vm.customer } }, [
              _vm._v("Customer Order")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.repoortData.address
        ? _c("div", { staticClass: "store-address" }, [
            _c("img", {
              attrs: { src: require("@/assets/img/explore/location.png") }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.repoortData.address))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.storeImgList && _vm.storeImgList.length > 0
        ? _c(
            "div",
            { staticClass: "store-img" },
            [
              _c(
                "awesome-swiper",
                {
                  attrs: {
                    pagination: _vm.pagination,
                    turnPages: _vm.turnPages,
                    swiperData: _vm.storeImg,
                    prevName: "storeImg",
                    nextName: "storeImg"
                  }
                },
                _vm._l(_vm.storeImgList, function(item, index) {
                  return _c("swiper-slide", { key: index }, [
                    _c("div", { staticClass: "card-img" }, [
                      _c("img", {
                        attrs: { src: item },
                        on: {
                          click: function($event) {
                            return _vm.$refs["imgPreviewRef"].init(item)
                          }
                        }
                      })
                    ])
                  ])
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "periphery-traffic" }, [
        _c("p", { staticClass: "content-title" }, [
          _vm._v("local pedestrian traffic")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", [_vm._v("Property:")]),
          _vm._v(" "),
          _c("div", { staticClass: "s-name" }, [
            _vm._v(_vm._s(_vm.repoortData.storeName))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "store-content",
              class: _vm.showTraffic ? "" : "filter-blur"
            },
            [
              _c("div", { staticClass: "content-data" }, [
                _c("div", { staticClass: "left-area" }, [
                  _c("span", [_vm._v("Store reviews")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "reviews" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            parseFloat(_vm.repoortData.avgRating).toFixed(1)
                          ) +
                          "\n                         "
                      ),
                      _c("el-rate", {
                        attrs: { disabled: "", "text-color": "#F3E93D" },
                        model: {
                          value: _vm.repoortData.avgRating,
                          callback: function($$v) {
                            _vm.$set(_vm.repoortData, "avgRating", $$v)
                          },
                          expression: "repoortData.avgRating"
                        }
                      }),
                      _vm._v(
                        "\n                          (" +
                          _vm._s(Number(_vm.repoortData["reviews"])) +
                          ")\n                      "
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "right-area" }, [
                  _c("span", [_vm._v("Median House Value")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "format",
                          rawName: "v-format",
                          value: "$#,##.##k",
                          expression: "'$#,##.##k'"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.repoortData["medianHomeValue"]
                            ? _vm.repoortData["medianHomeValue"] / 1000
                            : 0
                        )
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content-data",
                  staticStyle: { "margin-bottom": "10px" }
                },
                [
                  _c("div", { staticClass: "left-area" }, [
                    _c("span", [_vm._v("Median rent")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.repoortData["medianGrossRent"]
                            ? _vm.repoortData["medianGrossRent"] / 1000
                            : 0
                          ).toFixed(2)
                        ) + "K/Month"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "right-area" }, [
                    _c("span", [_vm._v("Web site")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            return _vm.openWebSite(_vm.repoortData["website"])
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.repoortData["website"]
                              ? _vm.repoortData["website"]
                              : "NA"
                          )
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          !_vm.showTraffic
            ? _c("div", { staticClass: "locked-content" }, [
                _c("i", { staticClass: "el-icon-lock" }),
                _vm._v(" "),
                _c("div", { on: { click: _vm.clickUpgrade } }, [
                  _vm._v("Upgrade To Unlock")
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "visits-trend" }, [
        _c("p", { staticClass: "content-title" }, [
          _vm._v("Ethnic composition")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", {
            ref: "chart",
            class: _vm.showTrend ? "" : "filter-blur",
            staticStyle: { width: "100%", height: "260px" }
          }),
          _vm._v(" "),
          !_vm.showTrend
            ? _c("div", { staticClass: "locked-content" }, [
                _c("i", { staticClass: "el-icon-lock" }),
                _vm._v(" "),
                _c("div", { on: { click: _vm.clickUpgrade } }, [
                  _vm._v("Upgrade To Unlock")
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "audience-overview" }, [
        _c("p", { staticClass: "content-title" }, [
          _vm._v("Audience Overview")
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                ref: "filterTable",
                staticStyle: { width: "100%" },
                attrs: {
                  "header-cell-style": { color: "#000000", fontSize: "14px" },
                  data: _vm.audienceTableData
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "date",
                    label: "Property",
                    width: "auto",
                    "column-key": "date"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "fontBond",
                              class: _vm.showAudienceOverview
                                ? ""
                                : "filter-blur"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(scope.row.storeName) +
                                  "\n                "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { staticClass: "store-address" }, [
                                _vm._v(" " + _vm._s(scope.row.storeAddress))
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "medianHousehold",
                    label: "Median Household",
                    width: "150"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "fontBond",
                              class: _vm.showAudienceOverview
                                ? ""
                                : "filter-blur"
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "format",
                                      rawName: "v-format",
                                      value: "$#,##0.00",
                                      expression: "'$#,##0.00'"
                                    }
                                  ],
                                  staticClass: "fontBond"
                                },
                                [
                                  _vm._v(
                                    _vm._s(Number(scope.row.income / 1000))
                                  )
                                ]
                              ),
                              _vm._v("k\n              ")
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "degree",
                    label: "Bachelor’s Degree",
                    width: "150"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "fontBond",
                              class: _vm.showAudienceOverview
                                ? ""
                                : "filter-blur"
                            },
                            [
                              _c("span", { staticClass: "fontBond" }, [
                                _vm._v(" " + _vm._s(scope.row.degree))
                              ]),
                              _vm._v("%\n              ")
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "medianAge",
                    label: "Median Age",
                    width: "150"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "fontBond",
                              class: _vm.showAudienceOverview
                                ? ""
                                : "filter-blur"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(scope.row.medianAge) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "mostCommonEthnicity",
                    label: "Most Common Ethnicity",
                    width: "180"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "fontBond",
                              class: _vm.showAudienceOverview
                                ? ""
                                : "filter-blur"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(scope.row.mostCommonEthnicity) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "personsPerHousehold",
                    label: "Persons per Household",
                    width: "180"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "fontBond",
                              class: _vm.showAudienceOverview
                                ? ""
                                : "filter-blur"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(scope.row.personsPerHousehold) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            !_vm.showAudienceOverview
              ? _c("div", { staticClass: "locked-content" }, [
                  _c("i", { staticClass: "el-icon-lock" }),
                  _vm._v(" "),
                  _c("div", { on: { click: _vm.clickUpgrade } }, [
                    _vm._v("Upgrade To Unlock")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "tips" }, [
              _vm._v(
                "*Demographics are based on a True Trade Area capturing 70%of visits | Data source: Census 2021"
              )
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vicinity" }, [
        _c("p", { staticClass: "content-title" }, [_vm._v("Vicinity")]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                ref: "vicinityTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.vicinityTableData }
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "rank", label: "Rank", width: "60" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "fontBond",
                              class: _vm.showVicinity ? "" : "filter-blur"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(scope.row.rank) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "name", label: "Name", width: "auto" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "fontBond",
                              class: _vm.showVicinity ? "" : "filter-blur",
                              staticStyle: { display: "flex" }
                            },
                            [
                              _vm._v(" " + _vm._s(scope.row.name) + " "),
                              _c("span", { staticClass: "store-info" }, [
                                _vm._v("/ " + _vm._s(scope.row.address))
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "visits", label: "Visits", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "format",
                                  rawName: "v-format",
                                  value: "#,##",
                                  expression: "'#,##'"
                                }
                              ],
                              staticClass: "fontBond",
                              class: _vm.showVicinity ? "" : "filter-blur",
                              staticStyle: { display: "flex" }
                            },
                            [_vm._v(" " + _vm._s(scope.row.visits) + " ")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            !_vm.showVicinity
              ? _c("div", { staticClass: "locked-content" }, [
                  _c("i", { staticClass: "el-icon-lock" }),
                  _vm._v(" "),
                  _c("div", { on: { click: _vm.clickUpgrade } }, [
                    _vm._v("Upgrade To Unlock")
                  ])
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("img-preview", {
        ref: "imgPreviewRef",
        attrs: { "src-list": _vm.storeImgList }
      }),
      _vm._v(" "),
      _c("ai-recommendations-upgrade-plan", { ref: "loadMore" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f51925ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f51925ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vilocal/explore-report.vue
// module id = GfBC
// module chunks = 2